const convertISOStringToPythonISOString = isoString => isoString.replace('T', ' ').replace('Z', '');

export default convertISOStringToPythonISOString;
